import { ChevronLeft, Plus } from "lucide-react"
import { Link, useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import useGetUserFlashcards from "@/modules/flashcards/queries/use-get-user-flashcards"
import CollapsableFlashcardList from "@/modules/flashcards/features/dashboard/collapsable-flashcard-list"
import { FlashcardsTutorial } from "@/modules/flashcards/components/flashcard-tutorial"
import RenameFlashcardModal from "@/modules/flashcards/features/dashboard/rename-flashcard-modal"
import DeleteFlashcardModal from "@/modules/flashcards/features/dashboard/delete-flashcard-modal"
import UpdateFlashcardModal from "@/modules/flashcards/features/dashboard/update-flashcard-modal"
import { useNoLifeAlert } from "@/modules/app/stores/use-no-life-alert"
import { useUser } from "@/modules/user/stores"
import { useLearningPaths } from "@/modules/app/stores/use-lp-store"
import StudySection from "./study-section"
import useUserPlan from "@/modules/user/hooks/use-user-plan"
import { useFinishFreeTrial } from "@/modules/user/hooks/use-finish-free-trial"
import useEndFreeTrialModal from "@/modules/plans/stores/use-end-free-trial"

const FlashcardsDashboardPage = () => {
  const navigate = useNavigate()
  const { setIsOpen: openNoLifeAlert } = useNoLifeAlert()
  const { selectedLearningPath } = useLearningPaths()
  const { user } = useUser()
  const { lives } = user
  const { isPro } = useUserPlan()
  const { isTrialFinished } = useFinishFreeTrial()
  const { onToggle } = useEndFreeTrialModal()

  const flashcardsQuery = useGetUserFlashcards({
    offset: 0,
    limit: 100,
    learningPathId: selectedLearningPath.id,
  })

  const handleOnAddNewFlashcard = () => {
    if (isTrialFinished) {
      onToggle()
      return
    }
    const canAddNewFlashcardAsFreeUser = lives > 0

    if (isPro || canAddNewFlashcardAsFreeUser) {
      navigate("/new-study-session?type=flashcards")
      return
    }

    if (!isPro && lives === 0) {
      openNoLifeAlert(true)
      return
    }
  }

  return (
    <>
      <div className="mx-auto h-full w-full max-w-3xl overflow-hidden px-3 pt-8">
        <Link
          to="/dashboard"
          className="mb-7 flex w-fit items-center justify-center gap-1 text-sm font-bold text-gray-500"
        >
          <ChevronLeft className="text-gray-500" />
          Volver
        </Link>

        <FlashcardsTutorial />

        <div className="my-5 flex items-center justify-between">
          <h4 className="text-xl font-bold text-black">Flashcards</h4>

          <div className="flex items-center justify-center gap-3">
            <Button
              onClick={handleOnAddNewFlashcard}
              className="flex w-fit items-center justify-center gap-1 rounded-[8px] border border-transparent bg-transparent px-3 py-2 text-sm font-bold text-orange-600 transition duration-200 hover:border-orange-500"
            >
              <Plus className="text-orange-600" />
              Nuevo
            </Button>

            <StudySection />
          </div>
        </div>

        <CollapsableFlashcardList flashcardsQuery={flashcardsQuery} />

        <Button
          onClick={handleOnAddNewFlashcard}
          className="mt-3 flex w-full items-center justify-center gap-1 rounded-lg border border-[#C7C7CC] bg-transparent py-2 text-sm font-bold text-black transition duration-200 hover:border-gray-400"
        >
          <Plus className="text-black" />
          Nuevo
        </Button>
      </div>

      <UpdateFlashcardModal />
      <RenameFlashcardModal />
      <DeleteFlashcardModal />
    </>
  )
}

export default FlashcardsDashboardPage
